import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

import { EntityLink, EntityLinkProps } from './EntityLink';


export interface RelatedEntityProps {
  label: string;
  link: EntityLinkProps;
}

export const RelatedEntity = (props: RelatedEntityProps) => {
  if (props.link) {
    return (
      <div className={DetailsTooltipStyles.MetadataSection} style={{ display: 'flex', flexDirection: 'row', minWidth: 0 }}>
        <div className={DetailsTooltipStyles.MetadataRelatedTitle} style={{ flexGrow: 0 }}>{props.label}</div>
        <EntityLink {...props.link} />
      </div>
    );
  } else {
    return null;
  }
};
